// extracted by mini-css-extract-plugin
export default {"logo":"inverter_logo__nothe","info":"inverter_info__8Suc4"};